import { createContext, Dispatch, SetStateAction } from 'react';
import utils from 'utils';
import { DataRoom } from '../../models/DataRoom';
import { DataRoomNode } from '../../models/DataRoomNode';
import { QAndARoles } from '../../models/QAndA';
import { DataRoomMemberRole } from '../../models/DataRoomMember';
import { BulkAvailabilityFileSettings } from '../../models/DataRoomBulk';

type DataRoomContextValues = {
  isAdmin: boolean;
  isQaAdmin: boolean;
  dataRoom: DataRoom;
  role: DataRoomMemberRole;
  qaRole: QAndARoles;
  isPublishingAllowed: boolean;
  canBuyerAskQuestion: boolean;
  canUserAskQuestion: boolean;
  canUserManageQuestionSubject: boolean;
  questionSubjects: string[];
  isClosedDataRoom: boolean;
  isDisabledDataRoom: boolean;
  isDisabledQA: boolean;
  refetchFlag: boolean;
  hasIndexGenerated: boolean;
  doesntHaveAccess: boolean;
  isEnterpriseHead: boolean;
  isSellSide: boolean;
  isBuySide: boolean;
  doesUserHaveAccessToQa: boolean;
  canUserCreateShareableLinks: boolean;
  canUserManageNda: boolean;
  fileSettingsInitialValues: BulkAvailabilityFileSettings;
  canAccessQaSettings: boolean;
  hasSeenDataRoomOnboarding: boolean;
  openBuyQaDrawer: () => void;
  refetch: () => void;
  setDataRoom: Dispatch<SetStateAction<DataRoom>>;
  setSelectedForQAndADrawerForDrawer: Dispatch<SetStateAction<DataRoomNode>>;
};

export default createContext<DataRoomContextValues>({
  isAdmin: false,
  isQaAdmin: false,
  role: null,
  qaRole: null,
  dataRoom: null,
  isPublishingAllowed: false,
  canBuyerAskQuestion: false,
  canUserAskQuestion: false,
  canUserManageQuestionSubject: false,
  questionSubjects: [],
  isClosedDataRoom: false,
  isDisabledDataRoom: false,
  isDisabledQA: false,
  refetchFlag: false,
  hasIndexGenerated: false,
  doesntHaveAccess: false,
  isEnterpriseHead: false,
  isSellSide: false,
  isBuySide: false,
  doesUserHaveAccessToQa: true,
  canUserCreateShareableLinks: false,
  canUserManageNda: false,
  fileSettingsInitialValues: null,
  canAccessQaSettings: false,
  hasSeenDataRoomOnboarding: true,
  openBuyQaDrawer: utils.noop,
  refetch: utils.noop,
  setDataRoom: utils.noop,
  setSelectedForQAndADrawerForDrawer: utils.noop,
});
